import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import React, { useContext, useRef } from 'react';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
var InternalOption = function InternalOption(props, ref) {
  var _classNames;
  var optionRef = useRef(null) || ref;
  var children = props.children,
    value = props.value,
    disabled = props.disabled,
    className = props.className,
    activeIndex = props.activeIndex,
    index = props.index,
    onChangeSelect = props.onChangeSelect,
    _props$city = props.city,
    city = _props$city === void 0 ? {} : _props$city,
    renderCityInfo = props.renderCityInfo,
    itemRender = props.itemRender,
    onChangeActiveIndex = props.onChangeActiveIndex;
  var id = city.id,
    name = city.name;
  var _useContext = useContext(ConfigContext),
    getPrefixCls = _useContext.getPrefixCls,
    prefixCls = _useContext.prefixCls;
  var selectOptionPrefixCls = getPrefixCls(prefixCls, 'city-picker-list-item');
  var isSelected = id !== undefined ? id === value : false;
  var optionCls = classNames(selectOptionPrefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(selectOptionPrefixCls, "-selected"), isSelected), _defineProperty(_classNames, "".concat(selectOptionPrefixCls, "-disabled"), disabled), _defineProperty(_classNames, "".concat(selectOptionPrefixCls, "-active"), activeIndex === index), _classNames));
  var handleClick = function handleClick(e) {
    e.preventDefault();
    if (disabled || id === undefined) return;
    onChangeSelect === null || onChangeSelect === void 0 ? void 0 : onChangeSelect(city);
  };
  var handleOnMouseEnter = function handleOnMouseEnter() {
    onChangeActiveIndex && onChangeActiveIndex(index);
  };
  var handleOnMouseLeave = function handleOnMouseLeave() {
    onChangeActiveIndex && onChangeActiveIndex(-1);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    ref: optionRef,
    className: optionCls,
    title: name,
    onClick: handleClick,
    onMouseEnter: handleOnMouseEnter,
    onMouseLeave: handleOnMouseLeave
  }, typeof itemRender === 'function' ? itemRender(city) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "".concat(selectOptionPrefixCls, "-content")
  }, children), /*#__PURE__*/React.createElement("span", {
    className: "".concat(selectOptionPrefixCls, "-info")
  }, renderCityInfo === null || renderCityInfo === void 0 ? void 0 : renderCityInfo(city, true)))));
};
var Option = /*#__PURE__*/React.forwardRef(InternalOption);
Option.displayName = 'CityPickerOption';
export default Option;